<div class="order-exception-details">
  <div class="order-exception-details__header">
    @if (orderException && !isArchived) {
      <span
        matTooltip="{{ isBeingWatched ? 'Remove from watch list' : 'Add to watch list' }}"
        class="material-symbols-outlined order-exception-details__header--watch"
        [ngClass]="{ 'order-exception-details__header--unwatched': !isBeingWatched }"
        (click)="toggleWatch()"
        >star</span
      >
    }
    <div style="width: 100%">{{ orderExceptionId }}</div>
    <a (click)="detailsClosed.emit()" class="material-symbols-outlined order-exception-details__header--close">close</a>
  </div>
  <div class="order-exception-details__content">
    <app-order-exception-table [orderExceptions]="orderExceptions"></app-order-exception-table>
  </div>
</div>
